// extracted by mini-css-extract-plugin
export default {"home":"Home_home__rq+4Q","main_container":"Home_main_container__6oxPW","slide_title":"Home_slide_title__ti9Vg","spinner":"Home_spinner__kF9Ns"};